import { render, staticRenderFns } from "./StockCorrectionList.vue?vue&type=template&id=9629ad9e"
import script from "./StockCorrectionList.vue?vue&type=script&lang=js"
export * from "./StockCorrectionList.vue?vue&type=script&lang=js"
import style0 from "./StockCorrectionList.vue?vue&type=style&index=0&id=9629ad9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports